import FileIcon from 'icons/File.icon';
import ImageIcon from 'icons/Image.icon';
import VideoIcon from 'icons/Video.icon';
import {
  Video,
  Image,
  Application,
  ApplicationImage,
} from '../components/DisplayDropzoneFile/DisplayDropzoneFile.component';

export const fileJsxWithTypeOpened = {
  image: Image,
  video: Video,
  application: Application,
  text: Application,
  message: Application,
} as const;

export const fileJsxWithType = {
  image: Image,
  video: Video,
  application: ApplicationImage,
  text: ApplicationImage,
  message: ApplicationImage,
} as const;

export const fileTypeIcon = {
  image: ImageIcon,
  video: VideoIcon,
  application: FileIcon,
  text: FileIcon,
  message: FileIcon,
} as const;

export type FileType = keyof typeof fileJsxWithType;

export type DropzoneFile = {
  _id: string;
  id: string;
  name: string;
  type: FileType;
  key: string;
  url: string;
  customFileName?: string;
  originalFileName?: string;
  originalType?: FileType;
  size?: number;
};

export type FileProps = {
  key: string;
  name: string;
  url: string;
  className?: string;
  typeSufix?: string;
  triggerDownload?: boolean;
};

const DROPZONE_LABELS: Record<FileType, string> = {
  image: 'chooseAPhoto',
  video: 'chooseAVideo',
  application: 'chooseAFile',
  text: 'chooseAFile',
  message: 'chooseAFile',
};

export const getProperLabel = (acceptFiles: string) => {
  if (!acceptFiles) return 'chooseAFile';
  const accept = acceptFiles.substring(0, acceptFiles.indexOf('/')) as FileType;
  return DROPZONE_LABELS[accept];
};

export type UploaderProps = {
  name: string;
  size: number;
  percentage: number;
  isFailed?: boolean;
  error?: string;
  icon?: React.FC;
  type?: string;
  parentId?: string;
  folderName?: string;
  replacingFileName?: string;
};
